/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import './AdministrativeArea.scss'
import { faMinusSquare, faPlusSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { DistrictModal } from '../../../models/administrativeArea/districtModal'
import { getDistrictsByProvinceId } from '../../../store/administrativeArea/selectors'
import District from './District'

export interface ProvinceProps {
  id: number
  name?: string
  code?: string
  isSelected?: boolean
}

const Province: FC<ProvinceProps> = ({ id, name, code }) => {
  const districtList = useSelector(getDistrictsByProvinceId(id))
  const [isSelected, setIsSelected] = useState(false)

  const renderDistrictList = () => {
    return districtList.map((district: DistrictModal, index: number) => {
      return (
        <ul className="custom-ul" key={`district-${district.id}`}>
          <District
            key={`district-${index}-${code}`}
            id={district.id}
            name={district.name}
            code={district.code}
            isSelected={district.isSelected}
            allDsSelected={district.allSelected}
          />
        </ul>
      )
    })
  }

  return (
    <div
      role="button"
      className="custom-permission-button"
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        setIsSelected(!isSelected)
      }}
    >
      <Container fluid>
        <Row>
          <Col className="align-self-center" sm={1}>
            {isSelected ? (
              <FontAwesomeIcon icon={faMinusSquare} />
            ) : (
              <FontAwesomeIcon icon={faPlusSquare} />
            )}
          </Col>
          <Col sm={11}>
            <Row
              className={
                isSelected ? 'custom-header-selected' : 'custom-header'
              }
            >
              {name}
            </Row>
          </Col>
        </Row>
        {isSelected && (
          <Row>
            <Col className="custom-inner-loop">{renderDistrictList()}</Col>
          </Row>
        )}
      </Container>
    </div>
  )
}

export default Province
